export const normalizePromoCode = (promoCode: MaybeUndefined<string>) => {
  const normalizedPromoCode = promoCode?.trim().toUpperCase();

  return normalizedPromoCode ? normalizedPromoCode : undefined;
};
